"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _ossUpload = require("@/utils/ossUpload");
var _appSetting = require("@/api/appSetting");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  data: function data() {
    return {
      activeName: 'android',
      dataObj: {
        androidFileList: [],
        androidPackageName: '',
        androidPsd: '',
        androidBookName: '',
        bcPhotoList: [],
        iosPackageName: '',
        iosFileList: [],
        iosMobileprovisionFileList: [],
        iosPsd: '',
        iosBcPhotoList: [],
        ios_bc_AppKey: ''
      }
    };
  },
  mounted: function mounted() {
    var _this = this;
    (0, _appSetting.getManifest)({
      type: 'packConfig'
    }).then(function (res) {
      if (res.data) {
        var obj = JSON.parse(res.data);
        _this.dataObj = (0, _objectSpread2.default)({}, obj);
      }
    });
  },
  methods: {
    save: function save() {
      var _this2 = this;
      this.$confirm('确认是否要保存？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _appSetting.saveManifest)({
          packConfig: JSON.stringify(_this2.dataObj, null, 2)
        }).then(function (res) {
          if (res.data) {
            _this2.$notify.success({
              title: '温馨提示',
              message: '操作成功！'
            });
          }
        });
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(file, fileName, val) {
        var pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _ossUpload.uploadOSS)(file.file, 'builds', fileName);
            case 1:
              pictureUrl = _context.v;
              console.log(pictureUrl);
              _t = val;
              _context.n = _t === 1 ? 2 : _t === 2 ? 3 : _t === 3 ? 4 : _t === 4 ? 5 : _t === 5 ? 6 : 7;
              break;
            case 2:
              this.dataObj.androidFileList = [{
                name: file.file.name,
                url: pictureUrl
              }];
              return _context.a(3, 7);
            case 3:
              this.dataObj.bcPhotoList = [{
                name: file.file.name,
                url: pictureUrl
              }];
              return _context.a(3, 7);
            case 4:
              this.dataObj.iosFileList = [{
                name: file.file.name,
                url: pictureUrl
              }];
              return _context.a(3, 7);
            case 5:
              this.dataObj.iosMobileprovisionFileList = [{
                name: file.file.name,
                url: pictureUrl
              }];
              return _context.a(3, 7);
            case 6:
              this.dataObj.iosBcPhotoList = [{
                name: file.file.name,
                url: pictureUrl
              }];
              return _context.a(3, 7);
            case 7:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function handleFileUpload(_x, _x2, _x3) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    handleRemove: function handleRemove(file, val) {
      switch (val) {
        case 1:
          this.dataObj.androidFileList = [];
          break;
        case 2:
          this.dataObj.bcPhotoList = [];
          break;
        case 3:
          this.dataObj.iosFileList = [];
          break;
        case 4:
          this.dataObj.iosMobileprovisionFileList = [];
          break;
        case 5:
          this.dataObj.iosBcPhotoList = [];
      }
    }
  }
};